var scrollPositionRightLoader = /** @class */ (function () {
    function scrollPositionRightLoader(element) {
        this.scrollPositionRightClassName = 'js-scroll-position-right';
        if (element) {
            new ScrollPositionRight(element);
        }
        else {
            var scrollPositionRightElements = document.getElementsByClassName(this.scrollPositionRightClassName);
            for (var i = 0; i < scrollPositionRightElements.length; i++) {
                new ScrollPositionRight(scrollPositionRightElements[i]);
            }
        }
    }
    return scrollPositionRightLoader;
}());
export default scrollPositionRightLoader;
var ScrollPositionRight = /** @class */ (function () {
    function ScrollPositionRight(scrollPositionRight) {
        this.resizeTimeout = 0;
        this.scrollPositionRight = scrollPositionRight;
        this.setScrollPositionRight();
        this.bindEvents();
    }
    ScrollPositionRight.prototype.bindEvents = function () {
        var _this = this;
        window.addEventListener('resize', function () { _this.onResize(); });
    };
    ScrollPositionRight.prototype.onResize = function () {
        var _this = this;
        window.clearTimeout(this.resizeTimeout);
        this.resizeTimeout = window.setTimeout(function () {
            _this.setScrollPositionRight();
        }, 300);
    };
    ScrollPositionRight.prototype.setScrollPositionRight = function () {
        this.scrollPositionRight.scrollLeft = this.scrollPositionRight.scrollWidth;
    };
    return ScrollPositionRight;
}());
export { ScrollPositionRight };
